import Track from '../utils/tracking';
import {SET_BANNER_BACKGROUND_DESKTOP, SET_BANNER_BACKGROUND_MOBILE} from './action-types';

const setDesktopBanner = desktopBanner => (
  {type: SET_BANNER_BACKGROUND_DESKTOP, desktopBanner}
);

const setMobileBanner = mobileBanner => (
  {type: SET_BANNER_BACKGROUND_MOBILE, mobileBanner}
);

export default siteCode => (dispatch) => {
  const mobileSiteBanner = `${siteCode}-banner-mobile.png`;
  const siteBanner = `${siteCode}-banner.png`;
  
  import(
    /* webpackChunkName: "[request]-background" */
    /* webpackExclude: /\.test\./ */
    // This can't be resolved yet due to a known issue with ESLint
    // See eg https://github.com/babel/babel-eslint/issues/799
    // eslint-disable-next-line prefer-template
    '../../pages/CompletePage/images/' + siteBanner
  )
    .then((importedBanner) => {
      dispatch(setDesktopBanner(importedBanner.default));
    })
    .catch((error) => {
      Track.track(`Failed to load banner ${siteBanner}. ${error}`);
    });
  
  import(
    /* webpackChunkName: "[request]-background-mobile" */
    /* webpackExclude: /\.test\./ */
    // This can't be resolved yet due to a known issue with ESLint
    // See eg https://github.com/babel/babel-eslint/issues/799
    // eslint-disable-next-line prefer-template
    '../../pages/CompletePage/images/' + mobileSiteBanner
  )
    .then((importedMobileBanner) => {
      dispatch(setMobileBanner(importedMobileBanner.default));
    })
    .catch((error) => {
      Track.track(`Failed to load mobile banner ${mobileSiteBanner}. ${error}`);
    });
};
